import React,{useState, useEffect} from 'react'
import HeroCard from '../../components/causeBranding/HeroCard'
import Popup from '../../components/popup/Popup';
import './TheImpactLeague.css'
import PartnersLogo from '../../components/causeBranding/PartnersLogo';
import Testimony from '../../components/home/testimony/Testimony';
import Accordion from '../../components/causeBranding/Accordion';
import WhatIsLeague from '../../components/theImpactLeague/WhatIsLeague';
import Benefits from '../../components/theImpactLeague/Benefits';
import OnePlatform from '../../components/theImpactLeague/OnePlatform';
import { images } from '../../assets';
import { loadGtag } from '../../utility/loadGtag';

function TheImpactLeague() {

  useEffect(() => {
    loadGtag();
  }, []);
  
  const [showPopup, setShowPopup] = useState(false);

  // Function to toggle the visibility of the pop-up form
  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  const faqs = [
    {
      question: 'What is The Impact League?',
      answer: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ratione modi incidunt doloremque eius recusandae quibusdam nihil beatae laudantium nesciunt praesentium?Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ratione modi incidunt doloremque eius recusandae quibusdam nihil beatae laudantium nesciunt praesentium?'
    },
    {
      question: 'What makes Impact one of a kind employee wellness platform?',
      answer: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ratione modi incidunt doloremque eius recusandae quibusdam nihil beatae laudantium nesciunt praesentium?'
    },
    {
      question: 'What no.of employees have we handled in a League?',
      answer: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ratione modi incidunt doloremque eius recusandae quibusdam nihil beatae laudantium nesciunt praesentium?'
    },
    {
      question: 'What is the cost to conduct a League?',
      answer: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ratione modi incidunt doloremque eius recusandae quibusdam nihil beatae laudantium nesciunt praesentium?'
    },
    {
      question: 'How do I get started?',
      answer: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ratione modi incidunt doloremque eius recusandae quibusdam nihil beatae laudantium nesciunt praesentium?'
    }
   
  ];

    const customClass={
        heroTextTitle:"impactHeroTitle",
        heroTextInfo:"impactTextInfo",
        customButton:"bookDemoButton",
        handMobile:"handimg",
        causeMobile:"leaderboard"
    };
  return (
    <>
    <HeroCard
      title="World’s most engaging people wellness platform"
      description="Get your employees healthier and happier with our fun fitness kindness programs - The Impact Leagues. Leagues are crafted and customized for you to meet your unique needs. Book a demo to know more."
      statistics={[
        { label: 'Leagues', value: '57' },
        { label: 'Employees', value: '103K' },
        { label: 'Volunteering minutes', value: '5M' }
      ]}
      buttonText="Book a Demo"
      className={customClass}
      onButtonClick={togglePopup}
      handMobileSrc={images.handleMobile}
      causeMobileSrc={images.leaderboard}
    />
    <PartnersLogo className="impactLeagueLogos" />
    <WhatIsLeague />
    <Benefits />
    {/* <Testimony /> */}
    {/* <Accordion faqs={faqs} Faqs="impactfaqs" /> */}
    <OnePlatform buttonText="Book a Demo" onButtonClick={togglePopup}  />
    <Popup showPopup={showPopup} togglePopup={togglePopup} />
      
    </>
  )
}

export default TheImpactLeague
